import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { injectTellentToolResultRenderers } from '@core/tellent-assistant-contracts';
import { ChatPart } from '@core/tellent-assistant-types';

import { TellentAssistantPartFallbackComponent } from '../fallback/tellent-assistant-part-fallback.component';

@Component({
  selector: 'tellent-assistant-tool-result-part',
  standalone: true,
  imports: [NgComponentOutlet, TellentAssistantPartFallbackComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (rendererCmp(); as cmp) {
      <ng-container *ngComponentOutlet="cmp; inputs: { payload: parsedPayload() }" />
    } @else {
      <tellent-assistant-part-fallback [reason]="part().name" [payload]="part().payload" />
    }
  `,
})
export class TellentAssistantToolResultPartComponent {
  public readonly part = input.required<Extract<ChatPart, { kind: 'tool-result' }>>();
  private readonly registry = injectTellentToolResultRenderers({ optional: true }) ?? [];

  private readonly match = computed(() => this.registry.find(r => r.toolName === this.part().name));

  protected readonly rendererCmp = computed(() => {
    const m = this.match();
    if (!m) return null;
    return m.schema.safeParse(this.part().payload).success ? m.component : null;
  });

  protected readonly parsedPayload = computed(() => {
    const m = this.match();
    if (!m) return null;
    const res = m.schema.safeParse(this.part().payload);
    return res.success ? res.data : null;
  });
}
